<div class="container-fluid">
    <div class="row my-5">
        <div class="col-md-12 text-center">
            <div class="container">
                <div class="row">
                    <div class="col-sm-8 mx-auto">
                        <div class="card card-body rounded-3">
                            <img src="assets/images/500.png" class="img-fluid">
                            <button class="btn btn-main mx-auto" routerLink="../dashboard"><i class="fas fa-arrow-left me-2"></i>Go To Home </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>